import $ from "jquery";

jQuery(document).ready(function ($) {
	$(".project-entry .feature-image-container").matchHeight();
	$(".project-entry h3").matchHeight();
	$(".project-entry-excerpt").matchHeight();
	$(".contained-cta-text, .contained-cta-image").matchHeight();
	$(".blog-entry .feature-image-container").matchHeight();
	$(".blog-entry h2").matchHeight();
	$(".blog-entry-excerpt").matchHeight();
	$(".project-filtered-entry h2.project-title").matchHeight();
});
